import { render, staticRenderFns } from "./Protocolo-cobranza.vue?vue&type=template&id=5b2e520c&scoped=true&"
import script from "./Protocolo-cobranza.vue?vue&type=script&lang=ts&"
export * from "./Protocolo-cobranza.vue?vue&type=script&lang=ts&"
import style0 from "./Protocolo-cobranza.vue?vue&type=style&index=0&id=5b2e520c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e520c",
  null
  
)

export default component.exports